import { render, staticRenderFns } from "./vEndChatModal.vue?vue&type=template&id=5b8d44ec"
import script from "./vEndChatModal.vue?vue&type=script&lang=js"
export * from "./vEndChatModal.vue?vue&type=script&lang=js"
import style0 from "./vEndChatModal.vue?vue&type=style&index=0&id=5b8d44ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports